import { render, staticRenderFns } from "./FormSeparator.vue?vue&type=template&id=0bac526b&scoped=true&"
import script from "./FormSeparator.vue?vue&type=script&lang=js&"
export * from "./FormSeparator.vue?vue&type=script&lang=js&"
import style0 from "./FormSeparator.vue?vue&type=style&index=0&id=0bac526b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac526b",
  null
  
)

export default component.exports